import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { 
  History as HistoryIcon, 
  ArrowUpRight, 
  FileText, 
  Trash2,
  TrendingDown
} from 'lucide-react';

const History = () => {
  const navigate = useNavigate();
  const [auditHistory, setAuditHistory] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('aifine_audits') || '[]');
    setAuditHistory(saved);
  }, []);

  const deleteAudit = (id) => {
    const updated = auditHistory.filter(a => a.id !== id);
    setAuditHistory(updated);
    localStorage.setItem('aifine_audits', JSON.stringify(updated));
  };

  const loadAudit = (audit) => {
    navigate('/dashboard', { state: { auditData: audit } });
  };

  return (
    <div className="flex h-screen bg-slate-50 font-inter text-blue-900 overflow-hidden">
      <Sidebar />
      <main className="flex-1 p-12 overflow-y-auto">
        <header className="flex justify-between items-center mb-12">
          <div>
            <h1 className="text-3xl font-black uppercase tracking-tighter italic">
              Audit <span className="text-blue-600">Vault History</span>
            </h1>
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-[0.2em] mt-2">
              Historical Liability Tracking & Progression
            </p>
          </div>
        </header>

        {auditHistory.length === 0 ? (
          <div className="bg-white p-20 rounded-[3rem] text-center border border-dashed border-slate-200">
            <HistoryIcon size={48} className="mx-auto mb-4 text-slate-200" />
            <p className="text-slate-400 font-bold uppercase text-[10px] tracking-widest">No previous audits found.</p>
          </div>
        ) : (
          <div className="space-y-6">
            {/* Legend / Header for the List */}
            <div className="grid grid-cols-12 px-8 text-[9px] font-black uppercase tracking-widest text-slate-400">
              <div className="col-span-4">Entity / Use Case</div>
              <div className="col-span-2">Date</div>
              <div className="col-span-3">Financial Exposure</div>
              <div className="col-span-3 text-right">Actions</div>
            </div>

            {auditHistory.map((audit) => (
              <div 
                key={audit.id}
                className="grid grid-cols-12 items-center bg-white p-8 rounded-3xl border border-slate-100 hover:shadow-xl hover:shadow-blue-500/5 transition-all group"
              >
                <div className="col-span-4">
                  <h3 className="font-black uppercase tracking-tight text-blue-900">{audit.context.clientName}</h3>
                  <p className="text-[9px] font-semibold text-blue-500 uppercase tracking-widest">{audit.context.aiUseCase}</p>
                </div>
                
                <div className="col-span-2 text-xs font-bold text-slate-400">
                  {audit.date}
                </div>

                <div className="col-span-3">
                  <span className="text-lg font-black text-red-600 italic tracking-tighter">
                    ${audit.summary.financialRisk?.toLocaleString()}
                  </span>
                </div>

                <div className="col-span-3 flex justify-end gap-4">
                  <button 
                    onClick={() => loadAudit(audit)}
                    className="flex items-center gap-2 bg-blue-50 text-blue-600 px-6 py-3 rounded-xl font-black text-[9px] uppercase tracking-widest hover:bg-blue-600 hover:text-white transition-all"
                  >
                    Load Report <ArrowUpRight size={14} />
                  </button>
                  <button 
                    onClick={() => deleteAudit(audit.id)}
                    className="p-3 text-slate-300 hover:text-red-500 transition-colors"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default History;